import { useState } from "react";
import { news } from "./data";
import "../styling/style.css";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function NewsReader() {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handlers for Next/Prev buttons
  const goToNext = () => {
    if (currentIndex < news.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const currentArticle = news[currentIndex];

  return (
    <div className="container news-container">
      <Nav />
      <section className="news">
        <div className="help-header">
          <h2>News</h2>
          <p className="feature-intro-description">
            Stay informed on the latest regulatory changes and compliance
            requirements in Phillipines
          </p>
        </div>
        <div className="news-content-wrapper">
          <div className="left-panel">
            <label className="news-article-label">Articles</label>
            <ul className="title-list">
              {news.map((article, index) => (
                <li
                  key={article.id}
                  onClick={() => setCurrentIndex(index)}
                  className={`title-item ${index === currentIndex ? "active" : ""}`}
                >
                  {article.title}
                </li>
              ))}
            </ul>
          </div>
          <div className="right-panel">
            <div className="article-content">
              <h1 className="article-title">{currentArticle.title}</h1>
              <div
                className="article-body"
                dangerouslySetInnerHTML={{ __html: currentArticle.content }}
              />
            </div>
            <div className="navigation">
              <button onClick={goToPrev} disabled={currentIndex === 0}>
                &larr; Previous Article
              </button>
              <button
                onClick={goToNext}
                disabled={currentIndex === news.length - 1}
              >
                Next Article &rarr;
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
